import React from 'react';
import {
  addPathToList, Asset_requirements_paragraph,
  Bills_list,
  Enable_customers_enter,
  File_type_pay_bill,
  getSubCategoryId, Scan_barcode_android,
  select_a_Bills,
  Show_account_balance_inc,
  where_customer_sees,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import { arrangeScreenInJson } from '../screens/ScreensOrdering';
import AssetRequirements from '../components/PanelsComponents/General/AssetRequirements';

//= ========================================================================
const Panel_D01_PayBillsBillsList = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'your_bills',
    'pay_now',
    'insert_another_bill',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({ sub_category: myScreen.sub_category, duplication_number: 0 });
  const service = globJSON.configurations.services[subCategoryId];
  const { select_bill } = service;
  const { enable_customer_to_bill_code_manually } = select_bill;

  const onValueChanged = (key, value) => {
    select_bill[key] = value;
    arrangeScreenInJson(globJSON, onConfigChanged);
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={select_a_Bills}
      panelSubHeadline={Bills_list}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/select_bill/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/select_bill/`)}
      tooltipsTitles={service.screens_ordering}
      paragraph={where_customer_sees}
      language={language}
    >
      <SwitcherPanel
        text={Enable_customers_enter}
        value={enable_customer_to_bill_code_manually}
        onValueChanged={(value) => {
          onValueChanged('enable_customer_to_bill_code_manually', value);
        }}
      />
      {enable_customer_to_bill_code_manually && (
      <SwitcherPanel
        text={Scan_barcode_android}
        value={select_bill.enable_customer_to_scan_barcode}
        onValueChanged={(value) => {
          onValueChanged('enable_customer_to_scan_barcode', value);
        }}
        internalFlag
      />
      )}
      <SwitcherPanel
        text={Show_account_balance_inc}
        value={select_bill.show_account_balance}
        onValueChanged={(value) => {
          onValueChanged('show_account_balance', value);
        }}
      />
      <AssetRequirements paragraph={Asset_requirements_paragraph} details={File_type_pay_bill} />
    </FullPagePanel>
  );
};

export default Panel_D01_PayBillsBillsList;
